<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmit" type="primary" size="small" :disabled="actionBusy" @click="submitApproval">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="actionBusy" @click="wfApprove">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="actionBusy" @click="wfReject">驳回</el-button>
            <el-button v-if="showApprove" type="primary" size="small" :disabled="actionBusy" @click="approveHandle">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="actionBusy" @click="unapproveHandle">弃审</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('sale:salesStockReturn:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('sale:salesStockReturn:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="deleteHandle">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="90px" :disabled="formReadonly">
      <el-row>
        <el-col :span="6">
          <el-form-item label="入库单号" prop="stockReturnCode">
            <el-input v-model="dataForm.stockReturnCode" :readonly="codeReadonly || !!dataForm.stockReturnId" :placeholder="codeReadonly ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入库日期" prop="stockReturnDate">
            <el-date-picker v-model="dataForm.stockReturnDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="销售退货单" prop="returnId">
            <el-select v-model="dataForm.returnId" filterable :clearable="false" placeholder="选择已审核退货单" style="width:100%" @change="onReturnChange">
              <el-option v-for="item in returnOptions" :key="item.returnId" :label="item.returnCode + ' / ' + item.customerName" :value="item.returnId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item label="客户"><span>{{ dataForm.customerName || '—' }}</span></el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注"><el-input v-model="dataForm.remark" /></el-form-item>
      <div v-if="!formReadonly" style="margin-bottom:8px;">
        <el-button type="primary" size="small" :disabled="!dataForm.returnId" @click="returnLineSelectorVisible = true">选择退货明细</el-button>
      </div>
      <el-table border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="130" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" />
        <el-table-column prop="quantity" label="入库数量" width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :min="0" :max="formReadonly ? Math.max(Number(scope.row.quantity || 0), Number(scope.row.remainQuantity || 0)) : Number(scope.row.remainQuantity || 0)" :precision="2" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column prop="wareHouseId" label="入库库位" min-width="180">
          <template slot-scope="scope">
            <warehouse-location-select v-model="scope.row.wareHouseId" />
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="70" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" @click="dataForm.lines.splice(scope.$index, 1)">删除</el-button></template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <sales-return-line-selector :visible.sync="returnLineSelectorVisible" :return-id="dataForm.returnId" :exclude-stock-return-id="dataForm.stockReturnId" @select-multiple="chooseReturnLines" />
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'
import SalesReturnLineSelector from '../../components/sales-return-line-selector/index.vue'
import request from '../../api/request'
import { docAction, docGet, docInfo, docSave } from '../../api/erp/doc'
import { fetchPerms } from '../../api/auth'
import { canShowDirectApproveButton, isWorkflowEditable, normalizeWorkflowDocUi, shouldShowWorkflowTrail } from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}
function blankForm(id) {
  return {
    stockReturnId: id || '', stockReturnCode: '', stockReturnDate: today(), returnId: '', returnCode: '',
    customerId: '', customerName: '', approveStatus: '0', workflowStatus: 'draft', workflowInstance: null,
    myPendingTask: null, workflowDocUi: null, remark: '', lines: []
  }
}

export default {
  components: { WorkflowTrailDialog, WarehouseLocationSelect, SalesReturnLineSelector },
  data() {
    return {
      visible: false, readonly: false, submitLoading: false, actionBusy: false, codeReadonly: false,
      workflowDocUiReady: false, trailVisible: false, returnLineSelectorVisible: false, returnOptions: [],
      prevReturnId: '', permCodes: [], dataForm: blankForm(),
      dataRule: {
        stockReturnCode: [{ required: true, message: '入库单号不能为空', trigger: 'blur' }],
        stockReturnDate: [{ required: true, message: '入库日期不能为空', trigger: 'change' }],
        returnId: [{ required: true, message: '请选择销售退货单', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() { return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc },
    formRules() {
      if (this.formReadonly) return {}
      const rules = { stockReturnDate: this.dataRule.stockReturnDate, returnId: this.dataRule.returnId }
      if (!this.codeReadonly) rules.stockReturnCode = this.dataRule.stockReturnCode
      return rules
    },
    dialogTitle() {
      if (this.readonly) return '查看销售退货入库'
      return this.dataForm.stockReturnId ? '修改销售退货入库' : '新增销售退货入库'
    },
    showViewToolbar() { return this.readonly && !!this.dataForm.stockReturnId },
    workflowUi() { return normalizeWorkflowDocUi(this.dataForm.workflowDocUi) },
    canEditDoc() { return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus) },
    allowSaveDirectApprove() {
      const ui = this.workflowUi
      return !!(ui && ui.workflowEnabled && !ui.definitionMatched && ui.directApproveAllowed)
    },
    showApprove() {
      if (!this.showViewToolbar || !this.workflowDocUiReady || String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      if (this.isAuth('sale:salesStockReturn:approve')) return true
      return this.allowSaveDirectApprove && (this.isAuth('sale:salesStockReturn:save') || this.isAuth('sale:salesStockReturn:update'))
    },
    showUnapprove() { return this.showViewToolbar && this.isAuth('sale:salesStockReturn:unapprove') && String(this.dataForm.approveStatus) === '2' },
    showSubmit() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      const uid = (this.$store.state.user || {}).id
      if (this.dataForm.createBy && uid && String(this.dataForm.createBy) !== String(uid)) return false
      return this.isAuth('sale:salesStockReturn:submit') || this.isAuth('sale:salesStockReturn:save') || this.isAuth('sale:salesStockReturn:update')
    },
    showWfApprove() {
      const task = this.dataForm.myPendingTask
      return this.showViewToolbar && this.isAuth('workflow:task:approve') && task && task.taskId
    },
    showWfReject() { return this.showWfApprove && this.isAuth('workflow:task:reject') },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar, workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi, workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        const uid = (this.$store.state.user || {}).id
        const inst = this.dataForm.workflowInstance
        if (!(this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId) && inst && uid && String(inst.submitBy) === String(uid)) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      if (!ui.definitionMatched && ui.directApproveAllowed) return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) return '已启用多级审批，请先在「审批流程定义」中配置销售退货入库流程后再提交。'
      return ''
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.actionBusy = false
      this.codeReadonly = false
      this.workflowDocUiReady = false
      this.prevReturnId = ''
      this.dataForm = blankForm(id)
      this.loadReturnOptions('').then(() => {
        this.$nextTick(() => { if (this.$refs.dataForm) this.$refs.dataForm.clearValidate() })
        if (!id) this.resolveCode()
        if (id) {
          docInfo('/sale/salesStockReturn', id).then(res => {
            const body = res.data || {}
            this.dataForm = {
              ...blankForm(id), ...body,
              stockReturnDate: (body.stockReturnDate || '').slice(0, 10),
              lines: (body.lines || []).map(line => ({
                ...line,
                remainQuantity: line.remainQuantity != null ? Number(line.remainQuantity) : Number(line.quantity)
              }))
            }
            this.prevReturnId = body.returnId || ''
            this.workflowDocUiReady = !!normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
            this.loadReturnOptions(body.returnId)
          }).catch(() => {})
        }
      })
    },
    loadReturnOptions(includeReturnId) {
      return docGet('/sale/salesStockReturn/approvedReturns', {
        includeReturnId: includeReturnId || '',
        excludeStockReturnId: this.dataForm.stockReturnId || ''
      }).then(res => {
        this.returnOptions = res.data || []
      }).catch(() => {})
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'salesStockReturn' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.stockReturnCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('stockReturnCode')
        })
      }).catch(() => {})
    },
    onReturnChange(returnId) {
      const row = this.returnOptions.find(item => item.returnId === returnId)
      if (!row) return
      const prevId = this.prevReturnId
      if (this.dataForm.lines.length && prevId && prevId !== returnId) {
        this.$confirm('更换退货单将清空明细，是否继续？', '提示', { type: 'warning' }).then(() => {
          this.applyReturn(row)
          this.prevReturnId = returnId
        }).catch(() => { this.dataForm.returnId = prevId })
        return
      }
      this.applyReturn(row)
      this.prevReturnId = returnId
    },
    applyReturn(row) {
      this.dataForm.returnId = row.returnId
      this.dataForm.returnCode = row.returnCode
      this.dataForm.customerId = row.customerId
      this.dataForm.customerName = row.customerName
      this.dataForm.lines = []
    },
    chooseReturnLines(rows) {
      const exists = new Set(this.dataForm.lines.map(line => line.returnLineId))
      rows.forEach(row => {
        if (exists.has(row.returnLineId)) return
        const qty = Number(row.remainQuantity || 0)
        this.dataForm.lines.push({
          returnLineId: row.returnLineId, stockOutLineId: row.stockOutLineId, materialId: row.materialId,
          materialCode: row.materialCode, materialName: row.materialName, quantity: qty, remainQuantity: qty, wareHouseId: ''
        })
      })
    },
    submitHandle() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.dataForm.lines.length) { this.$message.warning('请至少选择一条退货明细'); return }
        this.submitLoading = true
        docSave('/sale/salesStockReturn', this.dataForm, 'stockReturnId').then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    reload() { if (this.dataForm.stockReturnId) this.init(this.dataForm.stockReturnId, true) },
    approveHandle() {
      this.$confirm('审核后将增加库存（按原出库成本入库），是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesStockReturn', 'approve', { stockReturnId: this.dataForm.stockReturnId }).then(() => {
          this.$message.success('审核成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    unapproveHandle() {
      this.$confirm('弃审将回滚库存，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesStockReturn', 'unapprove', { stockReturnId: this.dataForm.stockReturnId }).then(() => {
          this.$message.success('弃审成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该退货入库单?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesStockReturn', 'delete', { stockReturnId: this.dataForm.stockReturnId }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    submitApproval() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert('尚未配置销售退货入库审批流程，请先在「审批流程定义」中新增并启用流程（至少一个审批步骤）后再提交。', '未配置审批流程', { type: 'warning', confirmButtonText: '我知道了' })
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/workflow/submit', { bizType: 'salesStockReturn', bizId: this.dataForm.stockReturnId }).then(() => {
          this.$message.success('提交成功'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfApprove() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfReject() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', { inputType: 'textarea', confirmButtonText: '驳回', inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; color: #e6a23c; font-size: 12px; line-height: 1.4; }
</style>
